<template>
  <div class="content">
    <div class="wrapper">
      <SvgIcone :icone="funcionalidade.parametros.dashboard.icone" :width="64" :height="64"
                :cor="esquemaDeCor.aplicacao.corPrimariaAplicacao" />
      <div class="text">
        <p>
          {{ text }}
        </p>
        <p>
          Tente mais tarde.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'RedeVazia',
  computed: {
    ...mapState('SetupApp', ['funcionalidade', 'esquemaDeCor']),
    text () {
      const name = this.funcionalidade.parametros.dashboard.nome
      return `${name} não disponível no momento.`
    }
  }
}
</script>

<style scoped>
.content {
  height: 100%;
  display: flex;
  place-content: center;
  place-items: center;
}

.wrapper {
  text-align: center;
}

.text {
  font-size: large;
}
</style>
